import * as React from "react"
import { SVGProps, Ref, forwardRef, memo } from "react"
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30.28 35.4"
    ref={ref}
    {...props}
  >
    <path
      d="M15.15 0a6.79 6.79 0 0 0-6.78 6.78v2.94h2.21V6.78a4.57 4.57 0 1 1 9.13 0v2.94h2.21V6.78A6.78 6.78 0 0 0 15.15 0Zm6.77 9.72V13a1.11 1.11 0 1 1-2.21 0V9.72h-9.13V13a1.11 1.11 0 1 1-2.21 0V9.72H1a1.1 1.1 0 0 0-1 1.1v23.47a1.11 1.11 0 0 0 1.11 1.11h28.07a1.11 1.11 0 0 0 1.1-1.11V10.82a1.1 1.1 0 0 0-1.1-1.1Z"
      data-name="Layer 2"
      style={{
        fill: "currentColor",
      }}
    />
  </svg>
)
const ForwardRef = forwardRef(SvgComponent)
const Memo = memo(ForwardRef)
export default Memo
